<template>
    <div class="container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
            <el-breadcrumb separator="">
                <el-breadcrumb-item>
                    <div class="div1">客户管理</div>
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/customers/customersTag' }">
                    <div class="div2">客户标签管理</div>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="行为标签" name="behaviorTags"></el-tab-pane>
                <!-- 这个版本先不做自定义标签 -->
                <!-- <el-tab-pane label="自定义标签" name="customTags"></el-tab-pane> -->
            </el-tabs>
        </div>
        <div v-if="activeName == 'behaviorTags'" class="headerbox">
            <div class="header">
                行为标签
            </div>
            <div class="behaviorTags-content">
                <div class="behaviorTags-content-left">
                    <el-tree ref="behaviorTree" :data="behaviorTagTable" @node-click="handleNodeClick" node-key="id"
                        :current-node-key="dataId">

                    </el-tree>
                </div>
                <div class="behaviorTags-content-right">
                    <el-table :data="behaviorTagsList" style="width: 100%;">
                        <el-table-column prop="id" label="序号" width="60">
                            <template slot-scope="scope">
                                {{ scope.$index + 1 }} <!-- 这里用索引+1生成从1开始的序号 -->
                            </template>
                        </el-table-column>
                        <el-table-column label="标签组名称" prop="groupName">
                            <template slot-scope="props">{{ props.row.groupName }}</template>
                        </el-table-column>
                        <el-table-column label="标签值" min-width="300">
                            <template slot-scope="props">{{ props.row.tagValues.join(',') }}</template>

                        </el-table-column>
                        <el-table-column label="操作" min-width="100">
                            <template slot-scope="props">
                                <el-switch v-model="props.row.status" :active-value="1" :inactive-value="2"
                                    @change="handleSwitchChange(props.row)">
                                </el-switch>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


export default {

    data() {
        return {
            allBehaviorTagsList: [],
            behaviorTagsList: [],
            tabValueList: [], //储存标签组的值
            activeName: 'behaviorTags',
            dataId: null,//类目的ID
            currentNode: null, //新增当前节点对象存储
            behaviorTagTable: [
                {
                    label: '消费分析',
                    id: 0,
                    children: [
                        {
                            label: '消费类目',
                            id: 1
                        },
                        {
                            label: '消费能力',
                            id: 2
                        }
                    ]
                },
                {
                    label: '其他',
                    id: 3,
                }

            ],
            status: 1,
            defaultProps: {
                children: 'children',
                label: 'label'
            }

        }
    },
    created() {
        // this.dataId = this.behaviorTagTable[0].id;
        this.dataId = this.behaviorTagTable[0].id;
        this.currentNode = this.behaviorTagTable[0];
        this.getBehaviorTags()
        
        // this.handleSwitchChange()
    },

    methods: {
        handleClick(tab) {
            // 处理标签点击事件
        },
        handleNodeClick(data) {

            this.dataId = data.id;
            const filterData = [...this.allBehaviorTagsList];
            console.log(data, 'data');
            if (data.children) {
                const childIds = data.children.map(child => child.id)
                this.behaviorTagsList = this.allBehaviorTagsList.filter(
                    item => childIds.includes(item.id)
                )
                console.log(this.behaviorTagsList, 'this.behaviorTagsList');

            } else {
                //过滤显示对应的数据
                this.behaviorTagsList = this.allBehaviorTagsList.filter(item => item.id == data.id)
            }
        },

        getBehaviorTags() {
            this.axios.get('/order/tag_customer/group/list').then((res) => {
                if (res.code == 0) {
                    this.allBehaviorTagsList = res.data;
                    console.log(res.data, '接口返回的数据sList');
                    this.$nextTick(() => {
                        if(this.$refs.behaviorTree){
                            this.$refs.behaviorTree.setCurrentKey(this.dataId);
                        }

                        if(this.currentNode){
                            this.handleNodeClick(this.currentNode);
                        }
                    });
                    this.behaviorTagsList = this.allBehaviorTagsList.filter(
                        item => item.id == this.dataId
                    )
                    // this.tabValueList = this.behaviorTagsList.flatMap(item => item.tagValues)
                    console.log(this.allBehaviorTagsList, 'this.allBehaviorTagsList');



                }
            })
        },
        handleSwitchChange(row) {
            const params = {
                status: row.status,
                id: row.id
            }
            this.axios.post('/order/tag_customer/group/updateStatus', params).then((res) => {
                if (res.code == 0) {
                    this.$message.success('修改成功！')

                }
            })
        }
    }

}
</script>
<style lang="scss" scoped>
.div1 {
    margin-left: -16px;
    background: url(../../assets/breadcrumb2.png);
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #2d7edf;
}

.div2 {
    margin-left: -16px;
    background: url(../../assets/breadcrumb1.png);
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #fff;
}

.headerbox {
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 24px;
    line-height: 50px;
    padding: 0 20px 0 20px;
    border-bottom: 1px solid #ededed;

    // padding-bottom: 10px;
    .header {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;


    }
}

.tabs {
    /deep/ .el-tabs__nav-wrap::after {
        background-color: transparent !important; // 将背景色改为透明
        height: 0 !important; // 将高度设为0
    }
}

.behaviorTags-content {
    display: flex;
    margin-top: 20px;
    height: 550px;


    .behaviorTags-content-left {
        width: 20%;
        border-right: 1px solid #f5f5f5;

        .el-tree {
            height: 100%;
            overflow-y: auto;
        }

    }



    /deep/.el-table .success-row {
        background: #f5f7fa;
    }


    /deep/ .el-tree-node__content {
        height: 56px;
        font-size: 16px;


    }


    /deep/.el-tree-node__label {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

    }

    /deep/.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
        background-color: #f0f7ff;
        color: #4168e7;
    }








    /* 自定义选中节点的背景颜色 */
    /deep/ .el-tree .is-current {
        background-color: #f0f7ff !important;
        color: #4168e7 !important;

    }

    .behaviorTags-content-right {
        width: 80%;
        height: 100%;
        font-size: 14px;
        letter-spacing: 3px;

        /deep/ .el-table th {
            height: 70px;
            background-color: #f5f5f5;
            color: #333333;
        }
    }
}
</style>